namespace advisorop.components.advisor {

    class RepFeeGroupWrapperController {

        $router;
        selectedCompanyGroup: domains.ICompanyGroup;
        selectedCompanyGroupId: number;
        companyGroupSel: domains.ICompanyGroup;;
        static $inject = [];
        constructor() {
        }

        newCompanyGroupSelected(advisorFirm: domains.ICompanyGroup): void {
            this.selectedCompanyGroup = advisorFirm;
            this.companyGroupSel = this.selectedCompanyGroup;
            //this.selectedCompanyGroupId = this.companyGroupSel.id;
        }
       
        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }
    }


    class RepFeeGroupWrapper implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                $router: "<",
               // advisorFirm: "<"
            };
            this.controller = RepFeeGroupWrapperController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/rep-fee-group-wrapper.html';
        }
    }

    angular.module(Constants.APP).component("repFeeGroupWrapper", new RepFeeGroupWrapper());
}